export default function DeleteAccount() {
  const sectionStyle = {
    marginBottom: '24px',
  };

  const headingStyle = {
    color: '#2c3e50',
    marginBottom: '12px',
  };

  const paragraphStyle = {
    lineHeight: '1.6',
    marginBottom: '12px',
  };

  const listStyle = {
    paddingLeft: '20px',
    lineHeight: '1.6',
  };

  return (
    <div
      style={{
        maxWidth: 800,
        margin: '0 auto',
        padding: '40px 20px',
        fontFamily: 'Segoe UI, sans-serif',
        color: '#333',
      }}
    >
      <h1 style={{ ...headingStyle, fontSize: '28px', textAlign: 'center' }}>
        Eliminar cuenta de la aplicación INTER
      </h1>

      <div style={sectionStyle}>
        <p style={paragraphStyle}>
          Esta página proporciona instrucciones para que los usuarios de la
          aplicación <strong>INTER</strong>, desarrollada por{' '}
          <strong>Sierrasoft SAS</strong>, puedan solicitar la eliminación de su
          cuenta y los datos personales asociados.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>
          ¿Cómo solicitar la eliminación de tu cuenta?
        </h2>
        <p style={paragraphStyle}>
          Para solicitar la eliminación de tu cuenta, debes enviar un correo
          electrónico a la siguiente dirección:
        </p>
        <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#d9534f' }}>
          seguridadindustrialdrummond@gmail.com
        </p>
        <p style={paragraphStyle}>En el correo debes incluir:</p>
        <ul style={listStyle}>
          <li>Tu nombre completo</li>
          <li>Tu identificación</li>
          <li>El correo electrónico asociado a tu cuenta</li>
          <li>
            Indicar claramente que deseas eliminar tu cuenta y tus datos
            personales
          </li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>¿Qué datos se eliminarán?</h2>
        <p style={paragraphStyle}>
          Una vez procesada la solicitud, se eliminarán los siguientes datos
          personales asociados a tu cuenta:
        </p>
        <ul style={listStyle}>
          <li>Nombre de usuario</li>
          <li>Número de identificación de usuario</li>
          <li>Dirección de correo electrónico</li>
          <li>Mensajes enviados</li>
          <li>Interacciones dentro de la aplicación</li>
          <li>Fotografías cargadas en el perfil de usuario</li>
        </ul>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>¿Qué datos se conservarán?</h2>
        <p style={paragraphStyle}>
          Por motivos legales o de seguridad, algunos registros técnicos no
          identificables personalmente (como registros de actividad del sistema
          o logs de auditoría) pueden conservarse durante un período adicional
          de <strong>hasta 30 días</strong> antes de su eliminación automática.
        </p>
      </div>

      <div style={sectionStyle}>
        <h2 style={headingStyle}>Tiempo de respuesta</h2>
        <p style={paragraphStyle}>
          Procesaremos tu solicitud en un plazo máximo de{' '}
          <strong>7 días hábiles</strong> y recibirás una confirmación por
          correo electrónico cuando se haya completado la eliminación.
        </p>
      </div>

      <p style={{ ...paragraphStyle, textAlign: 'center' }}>
        Gracias por usar la aplicación INTER.
      </p>
    </div>
  );
}
